module.exports = __webpack_public_path__ + "img/facts-ordering.07d058c2.svg";